<script lang="ts">
    import { get } from "svelte/store"
    import SvelteMarkdown from "../../../../../node_modules/svelte-markdown/src/SvelteMarkdown.svelte"
    import { getKirbyPage } from "../../../api/kirby/api"
    import { lang } from "../../../store"
    import LinkRerender from "./LinkRerender.svelte"
    async function processTextEditor(input: string) {
        let newText = input
        if (typeof newText !== "string") {
            return input
        }

        // Process link and email markers
        const linkEmailPattern = /\((link|email):\s*([^\)]+?)\s*text:\s*([^\)]+?)\)/g

        const linkEmailMatches = [...newText.matchAll(linkEmailPattern)]

        for (const m of linkEmailMatches) {
            const [fullMatch, type, target, text] = m
            let replacement = fullMatch

            if (type === "link") {
                if (target.startsWith("page://")) {
                    const res = await getKirbyPage(target)
                    replacement = `[${text.trim()}](/${get(lang)}/${res.url.split(`/${get(lang)}/`).pop()})`
                } else {
                    if (typeof text !== "string" || typeof target !== "string") {
                        console.warn("Invalid text or target in link marker:", text, target)
                        continue
                    }
                    const href = target?.trim()
                    const safeHref = href ? href.replace(/\(/g, "%28").replace(/\)/g, "%29") : ""
                    const safeText = text
                        ? text
                              .replace(/&/g, "&amp;") // zuerst & entkommen
                              .replace(/\[/g, "&#91;")
                              .replace(/\]/g, "&#93;")
                              .replace(/\(/g, "&#40;")
                              .replace(/\)/g, "&#41;")
                        : ""

                    // Escape parentheses in the text
                    replacement = `[${safeText}](${safeHref})`
                }
            } else if (type === "email") {
                console.log("email", text)
                replacement = `[${text.trim()}](mailto:${text.trim()})`
            }

            newText = newText.replace(fullMatch, replacement)
        }

        // Process file markers
        const filePattern = /\(file:\s*([^\)]+?)\)/g
        const fileMatches = [...newText.matchAll(filePattern)]

        for (const m of fileMatches) {
            const [fullMatch, target] = m
            const href = encodeURIComponent(target.trim())
            const replacement = `[${target.trim()}](${href})`
            newText = newText.replace(fullMatch, replacement)
        }

        return newText
    }

    let { text }: { text: string } = $props();
    let processedText = $state("");

    $effect(() => {
    const input = text;
    const l = $lang;

    let cancelled = false;

    if (typeof input === "string" && input) {
        processTextEditor(input /*, l */).then((out) => {
        if (!cancelled) processedText = out;
        });
    } else {
        processedText = "";
    }

    return () => {
        cancelled = true;
    };
    });
</script>

<div class="markdown">
    {#if processedText}
        <SvelteMarkdown
            source={processedText}
            renderers={{
                link: LinkRerender,
            }}
        />
    {/if}
</div>

<style lang="less" global>
    div.markdown {
        width: 100%;
        overflow: hidden;
        h4 {
            font-size: 1.25em;
            margin-top: 1em;
            margin-bottom: 0.3em;
        }

        h5,
        h6 {
            font-size: 1.1em;
            margin-top: 0.8em;
            margin-bottom: 0.3em;
            color: #555;
        }

        /* Absätze */
        p {
            margin-bottom: 1em;
        }

        /* Listen */
        ul,
        ol {
            padding-left: 2.4rem;
            margin-bottom: 1em;
        }

        /* Ensure nested lists remain indented */
        li > ul,
        li > ol {
            margin-top: 0.4em;
            margin-bottom: 0.4em;
            padding-left: 2rem;
        }

        ul {
            list-style-type: disc;
        }

        /* Keep ordered lists numeric on all nesting levels */
        ol,
        ol ol,
        ol ol ol,
        ol ol ol ol {
            list-style-type: decimal !important;
            list-style-position: outside;
        }

        li {
            margin-bottom: 0.3em;
        }

        /* Links */
        a {
            color: var(--brand-100);
            text-decoration: none;
        }

        a:hover {
            text-decoration: underline;
        }

        /* Zitate */
        blockquote {
            border-left: 4px solid #ddd;
            padding: 0.5em 1em;
            color: #555;
            margin: 1em 0;
            font-style: italic;
            background-color: #f9f9f9;
        }

        /* Code-Blöcke */
        pre {
            white-space: pre-wrap;
            padding: 10px;
            border-radius: 5px;

            font-size: 0.95em;
        }

        code {
            white-space: pre-wrap;
            padding: 2px 5px;
            border-radius: 3px;
        }

        pre code {
            display: block;
            padding: 10px;
        }

        /* Tabellen */
        table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 1em;
        }

        th,
        td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
        }

        th {
            background-color: #f4f4f4;
            font-weight: bold;
        }

        /* Horizontale Linie */
        hr {
            border: 0;
            height: 1px;
            background: #ddd;
            margin: 2em 0;
        }

        /* Bilder */
        img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 1em 0;
        }
        p {
            margin-bottom: 1.5rem;
            font-size: 1rem;
            white-space: pre-wrap;
        }
        strong {
            color: var(--dark-100);
            font-size: 1rem;
            font-weight: 700;
            text-transform: unset;
        }
    }
</style>
